export const MSG_CREATE_PRD_OK = 'Producto creado correctamente';
export const MSG_UPDATE_PRD_OK = 'Producto actualizado correctamente';
export const MSG_DELETE_PRD_OK = 'Producto eliminado correctamente';
export const MSG_DUPLICATE_PRD_OK = 'Producto duplicado correctamente';
export const MSG_CREATE_PRD_ERROR = 'Error al crear el producto';
export const MSG_UPDATE_PRD_ERROR = 'Error al actualizar el producto';
export const MSG_DELETE_PRD_ERROR = 'Error al eliminar el producto';
export const MSG_DUPLICATE_PRD_ERROR = 'Error al duplicar el producto';
export const MSG_LIST_PRD_ERROR = 'Error al consultar los productos';
export const MSG_DELETE_PRD = '¿Desea eliminar el Producto? esta acción no puede ser revertida';
export const MSG_SORT_PRD_OK = 'Productos reordenados correctamente';
export const MSG_SORT_PRD_ERROR = 'Error al reordenar productos';
export const MSG_PRD_DISABLED = 'Al desactivar todas las opciones, el producto se mostrará como no disponible';

export const MSG_CREATE_CAT_OK = 'Categoria creada correctamente';
export const MSG_UPDATE_CAT_OK = 'Categoria actualizada correctamente';
export const MSG_DELETE_CAT_OK = 'Categoria eliminada correctamente';
export const MSG_SORT_CAT_OK = 'Categorias reordenadas correctamente';
export const MSG_CREATE_CAT_ERROR = 'Error al crear la categoria';
export const MSG_UPDATE_CAT_ERROR = 'Error al actualizar la categoria';
export const MSG_DELETE_CAT_ERROR = 'Error al eliminar la categoria';
export const MSG_LIST_CAT_ERROR = 'Error al consultar las categorias';
export const MSG_ITEM_CAT_ERROR = 'Error al consultar la categoria';
export const MSG_SORT_CAT_ERROR = 'Error al reordenar categorias';
export const MSG_DELETE_CAT = '¿Desea eliminar la Categoría? esta acción no puede ser revertida';
